import React from 'react';
import {
  Drawer,
  Box,
  Button,
  TextField,
  Stack,
  Typography,
  Divider,
  Select,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material';
import { MIconButton } from 'components/@material-extend';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { InputLabel } from '@mui/material';
import { DatePicker } from '@mui/lab';
import roundManageSearch from '@iconify/icons-ic/round-manage-search';
import roundFilterList from '@iconify/icons-ic/round-filter-list';

interface DriverFiltersDrawerProps {
  open: boolean;
  onClose: () => void;
  filters: any;
  setFilters: React.Dispatch<React.SetStateAction<any>>;
  onApply: () => void;
  onClear: () => void;
}

const DriverFiltersDrawer: React.FC<DriverFiltersDrawerProps> = ({
  open,
  onClose,
  filters,
  setFilters,
  onApply,
  onClear
}) => {
  return (
    <>
      <Drawer anchor="right" open={open} onClose={onClose}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ px: 1, py: 2 }}
        >
          <Typography variant="subtitle1" sx={{ ml: 1 }}>
            Filters
          </Typography>
          <MIconButton onClick={onClose}>
            <Icon icon={closeFill} width={20} height={20} />
          </MIconButton>
        </Stack>

        <Divider />
        <Stack spacing={3} sx={{ p: 3 }}>
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Page Size
            </Typography>
            <FormControl fullWidth>
              <InputLabel>Page Size</InputLabel>
              <Select
                value={filters.pageSize}
                onChange={(e: any) => setFilters({ ...filters, pageSize: e.target.value })}
                label="Page Size"
              >
                <MenuItem value="10">10</MenuItem>
                <MenuItem value="25">25</MenuItem>
                <MenuItem value="50">50</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Search
            </Typography>
            <TextField
              label="Search"
              fullWidth
              value={filters.search}
              onChange={(e) => setFilters({ ...filters, search: e.target.value })}
            />
          </div>
          {/* Start Date */}
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Date From
            </Typography>
            <DatePicker
              label="Date From"
              inputFormat="dd/MM/yyyy"
              value={filters.dateFrom || null}
              onChange={(newValue) => setFilters({ ...filters, dateFrom: newValue })}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </div>
          {/* End Date */}
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Date To
            </Typography>
            <DatePicker
              label="Date To"
              inputFormat="dd/MM/yyyy"
              value={filters.dateTo || null}
              onChange={(newValue) => setFilters({ ...filters, dateTo: newValue })}
              renderInput={(params) => <TextField {...params} fullWidth />}
            />
          </div>
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Name
            </Typography>
            <TextField
              label="Name"
              fullWidth
              value={filters.name}
              onChange={(e) => setFilters({ ...filters, name: e.target.value })}
            />
          </div>
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Client
            </Typography>
            <TextField
              label="Client"
              fullWidth
              value={filters.client}
              onChange={(e) => setFilters({ ...filters, client: e.target.value })}
            />
          </div>
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Haulier
            </Typography>
            <TextField
              label="Haulier"
              fullWidth
              value={filters.haulier}
              onChange={(e) => setFilters({ ...filters, haulier: e.target.value })}
            />
          </div>
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Vehicle
            </Typography>
            <TextField
              label="Vehicle"
              fullWidth
              value={filters.DefaultVehicleIds}
              onChange={(e) => setFilters({ ...filters, DefaultVehicleIds: e.target.value })}
            />
          </div>
          <div>
            <Typography variant="subtitle1" gutterBottom>
              Inducted
            </Typography>
            <FormControl component="fieldset" fullWidth>
              <RadioGroup
                row
                value={filters.inducted}
                onChange={(e) => setFilters({ ...filters, inducted: e.target.value })}
              >
                <FormControlLabel value="Yes" control={<Radio size="small" />} label="Yes" />
                <FormControlLabel value="No" control={<Radio size="small" />} label="No" />
              </RadioGroup>
            </FormControl>
          </div>
        </Stack>
        <Box sx={{ p: 3, pb: 0 }}>
          <Button
            fullWidth
            size="large"
            type="submit"
            color="primary"
            variant="outlined"
            onClick={onApply}
            startIcon={<Icon icon={roundManageSearch} />}
          >
            Apply Filters
          </Button>
        </Box>
        <Box sx={{ p: 3 }}>
          <Button
            fullWidth
            size="large"
            type="submit"
            color="secondary"
            variant="outlined"
            onClick={onClear}
            startIcon={<Icon icon={roundFilterList} />}
          >
            Clear
          </Button>
        </Box>
      </Drawer>
    </>
  );
};

export default DriverFiltersDrawer;
